mutation DeleteContentPoll($id: ID!) {
  deleteContentPoll(id: $id) {
    id
  }
}
